module.exports = __webpack_public_path__ + "static/media/404-cake.9242bd7d.svg";